import { format } from 'd3-format';
import { Axis } from '../../../plot/components/Axis';
import { Scale } from '../../../plot/types/scale';
import { getExtent } from '../../../plot/utils/scale';

interface Props {
  scale: Scale;
  label?: string;
  offset?: number;
}
export const ClusterXAxis: React.FC<Props> = ({ scale, label, offset }) => {
  const duration = getExtent(scale.domain());
  return (
    <Axis
      formatter={format('d')}
      scale={scale}
      interval={duration / 5}
      position='bottom'
      label={label}
      height={offset}
    />
  );
};
